<template>
  <div class="home">
    <About />
  </div>
</template>

<script setup>
import About from "../components/About.vue";
</script>

<style lang="scss" scoped>
.home {
  min-height: 100%;
}
</style>
